export default __webpack_public_path__ + "static/media/Logo-No-Background-Blue-Text.944af3ad.png";